import SectionDivider from './SectionDivider'

export default SectionDivider
